import { DialogTitle, DialogTitleProps, styled } from "@mui/material";
import React from "react";
import { adjustBrightness } from "../../../../utils/adjustBrightness";

type WorkspaceTitleProps = DialogTitleProps & {
  destructive: boolean;
};

export const WorkspaceTitle = styled(DialogTitle, {
  shouldForwardProp: (prop) => prop !== "destructive",
})<WorkspaceTitleProps>(({ theme, destructive }) => ({
  justifyContent: "space-between",
  alignItems: "center",
  display: "flex",
  flex: "0 1 auto",
  flexWrap: "nowrap",
  color: theme.palette.secondary.contrastText,
  fontSize: theme.typography.h4?.fontSize,
  fontWeight: theme.typography.h4?.fontWeight,
  lineHeight: theme.typography.h4?.lineHeight,
  ...(destructive
    ? {
        backgroundImage: `linear-gradient(135deg,${theme.palette.error.main} 25%,${adjustBrightness(
          theme.palette.error.main,
          7
        )} 25%,${adjustBrightness(theme.palette.error.main, 7)} 50%,${
          theme.palette.error.main
        } 50%,${theme.palette.error.main} 75%,${adjustBrightness(
          theme.palette.error.main,
          7
        )} 75%,${adjustBrightness(theme.palette.error.main, 7)} 100%)`,
        backgroundSize: "56.57px 56.57px",
      }
    : {
        backgroundColor: theme.palette.primary.light,
      }),
})) as React.ComponentType<WorkspaceTitleProps>;
